var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71289 10.5C8.47416 10.5 10.7129 8.25647 10.7129 5.5C10.7129 2.73873 8.47416 0.5 5.71289 0.5C2.95642 0.5 0.712891 2.73873 0.712891 5.5C0.712891 8.25647 2.95642 10.5 5.71289 10.5ZM5.71289 6.2814C5.41088 6.2814 5.2335 6.11361 5.22392 5.80201L5.15201 3.53452C5.13763 3.21333 5.36773 2.98802 5.7081 2.98802C6.04846 2.98802 6.28336 3.21812 6.27377 3.53931L6.19707 5.80201C6.18748 6.11361 6.01011 6.2814 5.71289 6.2814ZM5.08969 7.39358C5.08969 7.72915 5.36773 7.96884 5.71289 7.96884C6.06284 7.96884 6.34089 7.73394 6.34089 7.39358C6.34089 7.05801 6.06284 6.81831 5.71289 6.81831C5.36294 6.81831 5.08969 7.05801 5.08969 7.39358Z",
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.5dd899df588e5713f610ed6134ccbcc3.svg";
export { ForwardRef as ReactComponent };